import React, { forwardRef, useEffect, useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';

/**
 * A signature pad whose drawing surface matches its on-screen size. A fixed
 * 500px canvas stretched to a narrow phone screen puts strokes in the wrong
 * place, so the canvas is resized to its container (which clears it).
 */
const FittedSignatureCanvas = forwardRef(({ height = 200 }, ref) => {
  const containerRef = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const node = containerRef.current;
    if (!node) return undefined;
    const measure = () => setWidth(Math.floor(node.getBoundingClientRect().width));
    measure();
    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', measure);
      return () => window.removeEventListener('resize', measure);
    }
    const observer = new ResizeObserver(measure);
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} style={{ position: 'absolute', inset: 0 }}>
      {width > 0 && (
        <SignatureCanvas
          ref={ref}
          canvasProps={{ width, height, className: 'signature-canvas', style: { display: 'block', touchAction: 'none' } }}
          backgroundColor="rgba(255, 255, 255, 0)"
        />
      )}
    </div>
  );
});

export default FittedSignatureCanvas;
